/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
import React from 'react'
import { connect } from 'react-redux'
import { Menu, Input, Icon, Form, Button, Grid, Header } from 'semantic-ui-react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import moment from 'moment'
import _ from 'lodash'
import RestaurantActions from '../../reducers/restaurantReducer'
import RecentListActions from '../../reducers/recentListReducer'
import firebase from '../../config/firebase'

class RecentStoresForm extends React.Component {
  state = {
    search: '',
    saving: false,
    publish: false,
    selectedRestaurantKeys: [],
  }

  componentDidMount() {
    const { fetchRestaurants, restaurantLoaded, recentListsLoaded, fetchRecentLists, recentList = {} } = this.props
    const { restaurants, publish } = recentList

    if (!restaurantLoaded) {
      fetchRestaurants()
    }

    if (!recentListsLoaded) {
      fetchRecentLists()
    }

    if (_.size(recentList) > 0) {
      const selectedRestaurantKeys = _.chain(restaurants)
        .reduce((result, restaurant, key) => {
          result.push({ ...restaurant, key })
          return result
        }, [])
        .sortBy('order')
        .map('key')
        .value()

      this.setState({ selectedRestaurantKeys, publish })
    }
  }

  setStateAsync = state => {
    return new Promise(resolve => this.setState(state, resolve))
  }

  onSaveClick = async () => {
    const { selectedRestaurantKeys, publish } = this.state
    const { history, firebaseKey, auth, recentLists, recentList } = this.props

    await this.setStateAsync({ saving: true })

    const newSelectedRestaurants = selectedRestaurantKeys.reduce((result, restaurantKey, index) => {
      result[restaurantKey] = {
        order: index + 1,
      }

      return result
    }, {})

    const updates = {}

    updates[`/recent_lists/${firebaseKey}/restaurants`] = newSelectedRestaurants
    updates[`/recent_lists/${firebaseKey}/publish`] = publish
    updates[`/recent_lists/${firebaseKey}/region`] = auth.region

    if (!recentList) {
      updates[`/recent_lists/${firebaseKey}/created_at`] = moment().format('x')
    }

    if (publish) {
      const publishedList = _.find(recentLists, { publish: true })

      if (publishedList && publishedList.key !== firebaseKey) {
        updates[`/recent_lists/${publishedList.key}/publish`] = false
      }
    }

    await firebase.database().ref().update(updates)
    await this.setStateAsync({ saving: false })
    history.push('/advertisement')
  }

  onRestaurantClick = restaurantKey => {
    const { selectedRestaurantKeys } = this.state

    if (selectedRestaurantKeys.includes(restaurantKey)) {
      this.setState({ selectedRestaurantKeys: selectedRestaurantKeys.filter(key => restaurantKey !== key) })
    } else {
      this.setState({ selectedRestaurantKeys: selectedRestaurantKeys.concat(restaurantKey) })
    }
  }

  onDragEnd = ({ source, destination }) => {
    if (!destination) return

    const { selectedRestaurantKeys } = this.state
    const arrangedSelectedRestaurants = Array.from(selectedRestaurantKeys)
    const [removed] = arrangedSelectedRestaurants.splice(source.index, 1);
    arrangedSelectedRestaurants.splice(destination.index, 0, removed);

    this.setState({ selectedRestaurantKeys: arrangedSelectedRestaurants })
  }

  onRemove = restaurantKey => {
    const { selectedRestaurantKeys } = this.state

    this.setState({ selectedRestaurantKeys: selectedRestaurantKeys.filter(key => key !== restaurantKey) })
  }

  renderRestaurant = restaurant => {
    const { selectedRestaurantKeys } = this.state

    return (
      <Menu.Item
        key={restaurant.key}
        active={selectedRestaurantKeys && selectedRestaurantKeys.includes(restaurant.key)}
        onClick={() => this.onRestaurantClick(restaurant.key)}
        style={styles.restaurant}
      >
        <div style={styles.restaurantRow} >
          <div style={styles.restaurantName}>
            {restaurant.name}
          </div>
          {
            selectedRestaurantKeys.includes(restaurant.key) && (
              <div style={styles.checkContainer} >
                <Icon name="check" color="green" />
              </div>
            )
          }
        </div>
      </Menu.Item>
    )
  }

  renderRestaurants = () => {
    const { restaurants } = this.props
    const { search } = this.state

    let displayRestaurants = Object.values(restaurants).filter(restaurant => {
      const restaurantName = (restaurant.name || '').toLowerCase()
      const searchText = search.toLowerCase().trim()

      return restaurant.status === 'publish' && restaurantName.includes(searchText)
    })

    displayRestaurants = _.sortBy(displayRestaurants, 'key').reverse()

    return (
      <div>
        <Input
          type="text"
          placeholder="Search"
          name="search-restaurant"
          onChange={e => this.setState({ search: e.target.value })}
          icon="search"
          style={{ width: '100%', marginTop: 10 }}
        />
        <Menu vertical style={styles.menu}>
          {
            displayRestaurants.map(restaurant => (
              this.renderRestaurant(restaurant)
            ))
          }
        </Menu>
      </div>
    )
  }

  renderSelectedRestaurants = () => {
    const { selectedRestaurantKeys } = this.state
    const { restaurants } = this.props

    return (
      <div style={{ marginTop: 20 }}>
        <Header as='h3' style={{ marginBottom: 22 }}>
          List of Selected Restaurants
        </Header>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="droppable">
            {({ droppableProps, innerRef, placeholder }) => (
              <div
                {...droppableProps}
                ref={innerRef}
              >
                {
                  selectedRestaurantKeys.map((restaurantKey, index) => (
                    <Draggable
                      key={restaurantKey}
                      draggableId={restaurantKey}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div style={styles.selectedRestaurantsContainer}>
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={styles.selectedRestaurantsRestaurant(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            {(restaurants[restaurantKey] || {}).name}
                            <div>
                              <Icon name="align justify" />
                            </div>
                          </div>
                          {
                            snapshot.isDragging ||
                            <div style={{ marginLeft: 8 }}>
                              <Button icon="remove" color="red" onClick={() => this.onRemove(restaurantKey)} />
                            </div>
                          }
                        </div>
                      )}
                    </Draggable>
                  ))}
                {placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    )
  }

  render() {
    const { restaurantLoading, recentListsLoading } = this.props
    const { saving, publish, selectedRestaurantKeys } = this.state

    return (
      <Form loading={restaurantLoading || recentListsLoading}>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>{this.renderRestaurants()}</Grid.Column>
            <Grid.Column>{this.renderSelectedRestaurants()}</Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Form.Field>
                <label>Status</label>
                <Button
                  color="black"
                  basic={!publish}
                  disabled={saving}
                  onClick={() => this.setState({ publish: true })}
                >
                  Publish
                </Button>
                <Button
                  color="black"
                  basic={publish}
                  disabled={saving}
                  onClick={() => this.setState({ publish: false })}
                >
                  Draft
                </Button>
              </Form.Field>
            </Grid.Column>
            <Grid.Column
              style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}
            >
              <Button
                color="black"
                basic={false}
                disabled={saving || _.size(selectedRestaurantKeys) === 0}
                onClick={this.onSaveClick}
              >
                Save
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    )
  }
}

const mapState = ({ restaurants, recentLists, auth }) => ({
  auth: auth.data,
  restaurants: restaurants.data,
  restaurantLoading: restaurants.loading,
  restaurantLoaded: restaurants.loaded,
  recentListsLoaded: recentLists.loaded,
  recentListsLoading: recentLists.loading,
  recentLists: recentLists.data,
})

const mapDispatch = {
  fetchRestaurants: RestaurantActions.fetchRestaurantsRequest,
  fetchRecentLists: RecentListActions.getRecentLists,
}

export default connect(
  mapState,
  mapDispatch
)(RecentStoresForm)

const styles = {
  menu: {
    maxHeight: 'calc(100vh - 350px)',
    overflow: 'auto',
    width: '100%'
  },
  restaurant: {
    padding: '13px 10px',
    borderRadius: 0
  },
  restaurantRow: {
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
  },
  restaurantName: {
    whiteSpace: 'normal',
    wordBreak: 'break-all',
    lineHeight: '1.3',
    display: 'flex',
    flex: 1,
    fontSize: 15,
  },
  checkContainer: {
    display: 'flex',
    width: 20,
    justifyContent: 'flex-end',
    marginLeft: 5,
  },
  selectedRestaurantsRestaurant: (isDragging, draggableStyle) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    userSelect: 'none',
    padding: 10,
    margin: `4px 0 4px 0`,
    background: isDragging ? 'black' : '#e0e1e2',
    width: '100%',
    borderRadius: `5px`,
    color: isDragging ? 'white' : 'rgba(0,0,0,.8)',
    ...draggableStyle,
  }),
  selectedRestaurantsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/components/advertisement/recentListForm.js